module.exports = __webpack_public_path__ + "img/sld_scb_8_t1_dark.2a22d9bf.svg";